module.exports = __webpack_public_path__ + "static/6import-423c2400a9f5a7d9f07a3c88e322c97a.png";